import { render, staticRenderFns } from "./allTeacher.vue?vue&type=template&id=71ff2b3e&scoped=true&"
import script from "./allTeacher.vue?vue&type=script&lang=js&"
export * from "./allTeacher.vue?vue&type=script&lang=js&"
import style0 from "./allTeacher.vue?vue&type=style&index=0&id=71ff2b3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ff2b3e",
  null
  
)

export default component.exports